import { ErrorCode } from '../../ErrorCode';

const ACCOUNT_EXISTS_API = 'https://api.jashsoft.com/auth/account-exists';

class CheckUserAccount {
  action(modelInstance) {
    return fetch(ACCOUNT_EXISTS_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerEmail: modelInstance.emailAddress
      })
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Account check failed');
      }
      return response.json();
    }).then((data) => {
      if (!data.exists) {
        return;
      }

      if (data.userStatus === 'UNCONFIRMED') {
        throw ErrorCode.SignUp.UnconfirmedAccountExists;
      }

      throw ErrorCode.SignUp.UsernameExists;
    });
  }
}

export default CheckUserAccount;
